import { Switch } from "react-router-dom";
import AuthRoute from "components/AuthRoute";

import RelatorioEmailScreen from "./Email";
import FinanceiroScreen from "./Financeiro";
import RelatorioUnidades from "./Unidades";
import RelatorioAuditoria from "./Auditoria";
import CertidaoNegativaDebitos from "./CertidaoNegativaDebitos";
import RelatorioReservas from "./Reservas";
import { PermissaoEnum } from "./../../../../core/resources/enums/permissao";

function RelatoriosPages() {
  return (
    <>
      <Switch>
        <AuthRoute
          path="/relatorios/email"
          component={RelatorioEmailScreen}
          permissions={[
            PermissaoEnum.Backoffice.Relatorios.Email.toString(),
            PermissaoEnum.Backoffice.Relatorios.Email.Visualizar,
          ]}
        />

        <AuthRoute
          path="/relatorios/financeiro"
          component={FinanceiroScreen}
          permissions={[
            PermissaoEnum.Backoffice.Relatorios.Financeiro.toString(),
            PermissaoEnum.Backoffice.Relatorios.Financeiro
              .DemonstrativoReceitaDespesa,
            PermissaoEnum.Backoffice.Relatorios.Financeiro
              .DemonstrativoReceitaDespesaAnual,
            PermissaoEnum.Backoffice.Relatorios.Financeiro
              .DemonstrativoReceitaDespesaAnual,
            PermissaoEnum.Backoffice.Relatorios.Financeiro.Inadimplentes,
            PermissaoEnum.Backoffice.Relatorios.Financeiro.PrestacaoContas,
            PermissaoEnum.Backoffice.Relatorios.Financeiro.Receitas,
            PermissaoEnum.Backoffice.Relatorios.Financeiro.TotalDespesas,
            PermissaoEnum.Backoffice.Relatorios.Financeiro.ComposicaoReceitas,
            PermissaoEnum.Backoffice.Relatorios.Financeiro
              .ComposicaoReceitasHorizontal,
          ]}
        />

        <AuthRoute
          path="/relatorios/auditoria"
          component={RelatorioAuditoria}
        />

        <AuthRoute
          path="/relatorios/unidades/certidao-negativa-debitos"
          exact
          permissions={[
            PermissaoEnum.Backoffice.Relatorios.Unidades.toString(),
            PermissaoEnum.Backoffice.Relatorios.Unidades
              .CertidaoNegativaDebitos,
          ]}
          component={CertidaoNegativaDebitos}
        />

        <AuthRoute
          path="/relatorios/unidades"
          exact
          permissions={[
            PermissaoEnum.Backoffice.Relatorios.Unidades.toString(),
            PermissaoEnum.Backoffice.Relatorios.Unidades.Visualizar,
          ]}
          component={RelatorioUnidades}
        />

        <AuthRoute
          path="/relatorios/reservas"
          exact
          permissions={[
            PermissaoEnum.Backoffice.Relatorios.Unidades.toString(),
            PermissaoEnum.Backoffice.Relatorios.Unidades.Visualizar,
          ]}
          component={RelatorioReservas}
        />
      </Switch>
    </>
  );
}

export default RelatoriosPages;
